import { Component, Input } from "@angular/core";
import { IDetailCardItem } from "./details-card.interface";

@Component({
  selector: "app-details-card",
  templateUrl: "./details-card.component.html",
  styleUrls: ["./details-card.component.css"],
})
export class DetailsCardComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() items: IDetailCardItem[] = [];

  get visibleItems() {
    return this.items.filter(i => i.condition !== false);
  }
}
